module.exports = __webpack_public_path__ + "static/media/Background2.d2d12cf4.png";